import React from 'react';
import { Box } from '@mui/material';
import { ContentSectionId } from 'src/components/BeaconV2Components/ExperimentalLayout/ContentV3/hooks/ContentSectionId';
import {
  ContentAccuracyTitles,
  ContentUtilizationTitles,
  ContentUtilizationType
} from 'src/components/BeaconV2Components/ExperimentalLayout/ContentV3/components/ContentBarPercent/utils';

/** Matches mock `.newtag` in content-analytics.html */
export const NewFieldTag = () => (
  <Box
    component="span"
    sx={{
      display: 'inline-flex',
      alignItems: 'center',
      height: '18px',
      padding: '0 8px',
      borderRadius: '10px',
      backgroundColor: '#EDF5FF',
      color: '#2C6CBF',
      fontSize: '11px',
      fontWeight: 700,
      letterSpacing: '0.3px',
      marginLeft: '8px',
      verticalAlign: 'middle',
      textTransform: 'none',
      lineHeight: '18px',
      flexShrink: 0
    }}
  >
    NEW
  </Box>
);

export const isItemHighlightsLabel = (title: string): boolean => {
  const normalized = title.trim().toLowerCase();
  return (
    normalized.includes('item highlight') ||
    title === ContentSectionId.ItemHighlights ||
    title === ContentUtilizationTitles.ItemHighlights ||
    title === ContentAccuracyTitles.ItemHighlights ||
    title === ContentUtilizationType.ItemHighlights
  );
};

/** Renders a content-field label. */
export const ContentFieldLabel = ({ title }: { title: string }) => <>{title}</>;
